import { addNotification } from "@/core/services/NotificationService";
import { getWord } from "../translator";
import JobStateValue from "@/models/enums/JobState";
import { toLocalDate } from "../dateHelper";
import NotificationDialog from "../notificationDialog";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import store from "@/store";

const onJobCreated = (newJob: any) => {
    if (newJob) {
        addNotification({
            title: "JobCreated",
            description: `ClickTitleToViewLogs`,
            time: toLocalDate(Date.now()),
            route: `/automation/log/list?jobId=${newJob.id}`
        });

        if (store.getters.getDataType == "Job") {
            const data = {
                id: newJob.id,
                companyId: newJob.companyId,
                processName: newJob.process?.name || "-",
                robotName: newJob.robot?.name || "-",
                byteState: newJob.state,
                state: getWord(JobStateValue.GetText(newJob.state)),
                started: toLocalDate(newJob.started),
                ended: toLocalDate(newJob.ended),
                createdAt: newJob.createdAt
            };
            if (store.getters.getTableData.length === store.getters.getPageSize) {
                const newList = [{ isNew: true, ...data }, ...store.getters.getTableData.slice(0, store.getters.getPageSize - 1)];
                store.commit(Mutations.SET_TABLE_DATA, newList);
            }
            else {
                const newList = [{ isNew: true, ...data }, ...store.getters.getTableData];
                store.commit(Mutations.SET_TABLE_DATA, newList);
            }
        }
    }
}

const onJobStateChanged = (updatedJob: any) => {
    if (updatedJob) {
        const state = updatedJob.status
        if (state === 3) {
            addNotification({
                title: "JobFaulted",
                description: `ClickTitleToViewLogs`,
                time: toLocalDate(Date.now()),
                route: `/automation/log/list?jobId=${updatedJob.id}`
            });

            NotificationDialog.NotifyError("JobFaulted", updatedJob.process?.name || "-")
        }
        else if (state === 5) {
            addNotification({
                title: "JobStopped",
                description: `ClickTitleToViewLogs`,
                time: toLocalDate(Date.now()),
                route: `/automation/log/list?jobId=${updatedJob.id}`
            });

            NotificationDialog.NotifyError("JobStopped", updatedJob.process?.name || "-")
        }
        else if (state === 4) {
            addNotification({
                title: "JobSuccessfull",
                description: `ClickTitleToViewLogs`,
                time: toLocalDate(Date.now()),
                route: `/automation/log/list?jobId=${updatedJob.id}`
            });

            NotificationDialog.Notify("JobSuccessful", updatedJob.process?.name || "-")
        }

        if (store.getters.getDataType == "Job") {
            const list = store.getters.getTableData.map((_data) => {
                if (_data.id === updatedJob.id) {
                    _data.isUpdated = true;
                    _data.processName = updatedJob.process?.name || "-";
                    _data.robotName = updatedJob.robot?.name || "-";
                    _data.byteState = updatedJob.state;
                    _data.state = getWord(JobStateValue.GetText(updatedJob.state));
                    _data.started = toLocalDate(updatedJob.started);
                    _data.ended = toLocalDate(updatedJob.ended);
                    _data.createdAt = toLocalDate(updatedJob.createdAt);
                }

                return _data;
            });

            store.commit(Mutations.SET_TABLE_DATA, list);
        }
    }
}

const onJobStatisticsChanged = (statistics) => {
    if (statistics && statistics.data && statistics.data.job) {
        store.dispatch(Actions.SET_JOB_STATISTICS, statistics.data.job)
    }
}

export { onJobCreated, onJobStateChanged, onJobStatisticsChanged }